var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 9.5L12 12.625L7.2 9.5V8.25L12 11.375L16.8 8.25V9.5ZM16.8 7H7.2C6.534 7 6 7.55625 6 8.25V15.75C6 16.0815 6.12643 16.3995 6.35147 16.6339C6.57652 16.8683 6.88174 17 7.2 17H16.8C17.1183 17 17.4235 16.8683 17.6485 16.6339C17.8736 16.3995 18 16.0815 18 15.75V8.25C18 7.55625 17.46 7 16.8 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.696094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18182 0H17.7851C21.2231 0 24 2.77686 24 6.21488V17.8182C24 21.2231 21.2231 24 17.8182 24H6.18182C2.77686 24 0 21.2231 0 17.8182V6.18182C0 2.77686 2.77686 0 6.18182 0ZM17.8177 23.3388C20.859 23.3388 23.3383 20.8595 23.3383 17.8182V6.21486C23.3383 3.17354 20.859 0.694196 17.8177 0.694196H6.18131C3.13998 0.694196 0.660645 3.17354 0.660645 6.21486V17.8182C0.660645 20.8595 3.13998 23.3388 6.18131 23.3388H17.8177Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.97451563fd2b4b55e799af7ea0a8c593.svg";
export { ForwardRef as ReactComponent };